import React from "react"
import { Link } from "react-router-dom"

const SettingsLink = () => ( 
  <div className="menu-button">
    <Link className="settings" to="/settings">Settings</Link>
  </div>
)

export default SettingsLink